'use strict';

import React from 'react';
import { useEffect, useState, useContext } from 'react';

import { Button, ButtonGroup, Form, Modal, Row, Col } from 'react-bootstrap';

import { Formik } from 'formik';
import * as yup from 'yup';

import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction'
import deLocale from '@fullcalendar/core/locales/de';

import Slider from 'rc-slider';

import useRequest from '../helper/useRequest';
import { toast } from 'react-toastify';
import Alert from '../helper/Alert';
import useConfirmation from '../helper/Confirmation';
import { getHolidays } from '../helper/DateTimeFormater';

import Select from 'react-select';
import AppContext from '../AppContext';
import Loader from '../helper/Loader';
import { useMemo } from 'react';

const schema = yup.object().shape({
    PostCode: yup.string().length(5).matches(/^[0-9]{5}/),
});

const perimeters = [
    { value: '0', label: 'Keine' },
    { value: '25', label: '25 Km' },
    { value: '50', label: '50 Km' },
    { value: '75', label: '75 Km' }
]

const states = [
    { value: 'Baden-Württemberg', label: 'Baden-Württemberg' },
    { value: 'Bayern', label: 'Bayern' },
    { value: 'Berlin', label: 'Berlin' },
    { value: 'Brandenburg', label: 'Brandenburg' },
    { value: 'Bremen', label: 'Bremen' },
    { value: 'Hamburg', label: 'Hamburg' },
    { value: 'Mecklenburg-Vorpommern', label: 'Mecklenburg-Vorpommern' },
    { value: 'Niedersachsen', label: 'Niedersachsen' },
    { value: 'Nordrhein-Westfalen', label: 'Nordrhein-Westfalen' },
    { value: 'Rheinland-Pfalz', label: 'Rheinland-Pfalz' },
    { value: 'Saarland', label: 'Saarland' },
    { value: 'Sachsen', label: 'Sachsen' },
    { value: 'Sachsen-Anhalt', label: 'Sachsen-Anhalt' },
    { value: 'Schleswig-Holstein', label: 'Schleswig-Holstein' },
    { value: 'Thüringen', label: 'Thüringen' },
]

const ModalForm = ({ modal, setModal, event, deleteTimeslots, changeStatus }) => {
    const { request } = useRequest();
    const [business, setBusiness] = useState({});
    const context = useConfirmation();
    const closeModal = () => {
        setModal(false);
    }
    const [message, setMessage] = useState("");

    const now = new Date();
    var d = new Date(event.start);
    var dd = String(d.getDate()).padStart(2, '0');
    var mm = String(d.getMonth() + 1).padStart(2, '0');
    var yyyy = d.getFullYear();

    var today = dd + '.' + mm + '.' + yyyy + ", " + d.toLocaleDateString("de-DE", { weekday: 'short' });

    console.log(event.extendedProps);

    const cancelEvent = async (id) => {
        try {
            setMessage("");
            const result = await request("/Operator/CancelTimeslot", { timeslotId: id });
            const json = result.data;

            if (json.r == 1) {
                changeStatus(id, json.cancelOnTime ? 1 : 3);
                closeModal();
                toast.success("Terminstornierung erfolgreich.");
            }
            else {
                setMessage(json.message);
            }
        }
        catch (ex) {
            toast.error("Es ist ein Fehler aufgetreten.");
        }
    }

    const deleteEvent = async (id) => {
        try {
            setMessage("");
            const result = await request("/Operator/DeleteTimeslot", { timeslotId: id });
            const json = result.data;

            if (json.r == 1) {
                deleteTimeslots(id);
                closeModal();
                toast.success("Terminlöschung erfolgreich.");
            }
            else {
                setMessage(json.message);
            }
        }
        catch (ex) {
            toast.error("Es ist ein Fehler aufgetreten.");
        }
    }

    const loadBusiness = async () => {
        if (event.extendedProps.bookedBusiness == 0) {
            setBusiness(false);
        } else {
            const result = await request("/Operator/GetBusiness", { id: event.extendedProps.bookedBusiness });
            const json = result.data;
            if (json.r == 1) {
                setBusiness(json.business);
            }
            else {
                toast.error(json.message);
            }
        }
    }

    function getButton(business, event) {
        let d = new Date(event.start);
        if (d < now) return;
        if (event.extendedProps.status > 3) return;
        if (business) {
            return <>
                {event.extendedProps.status == 2 && <Button variant="danger" onClick={() => context.openModal("Wirklich stornieren?", "Möchten Sie diesen Termin wirklich stornieren?", () => { cancelEvent(event.id) }, "Ja", "Nein")}>Stornieren</Button>}
                <Button variant="danger" onClick={() => context.openModal("Wirklich löschen?", "Möchten Sie diesen Termin wirklich löschen?", () => { deleteEvent(event.id) }, "Ja", "Nein")}>Löschen</Button>
            </>;
        } else {
            return <Button variant="danger" onClick={() => context.openModal("Wirklich löschen?", "Möchten Sie diesen Termin wirklich löschen?", () => { deleteEvent(event.id) }, "Ja", "Nein")}>Löschen</Button>;
        }
    }

    useEffect(() => {
        if (!event) return;
        setMessage("");
        if (event.extendedProps.status == 3) {
            setMessage("Der Termin wurde vom Unternehmen storniert.");
        } else if (event.extendedProps.status == 4) {
            setMessage("Der Termin wurde vom Benutzer gelöscht.");
        }
        loadBusiness();
    }, [event]);

    

    if (!event) return null;

    return (
        <Modal show={modal} onHide={closeModal}>
            <Modal.Header closeButton>
                <Modal.Title>Zeitsatz: {event.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {message && <Alert type="error" message={message} />}
                <Row>
                    <Col sm={4}>
                        Schule
                    </Col>
                    <Col sm={8}>
                        <a href={"/Operator/Business/" + event.extendedProps.organisationId}>{event.extendedProps.organisationName}</a>
                    </Col>
                </Row>
                <Row>
                    <Col sm={4}>
                        Typ
                    </Col>
                    <Col sm={8}>
                        {event.extendedProps.typeOfSchool}
                    </Col>
                </Row>
                <Row>
                    <Col sm={4}>
                        Stufe
                    </Col>
                    <Col sm={8}>
                        {event.extendedProps.grade}
                    </Col>
                </Row>
                <Row>
                    <Col sm={4}>
                        Klasse
                    </Col>
                    <Col sm={8}>
                        {event.extendedProps.class}
                    </Col>
                </Row>
                {event.extendedProps.room && (
                    <Row>
                        <Col sm={4}>
                            Raum
                        </Col>
                        <Col sm={8}>
                            {event.extendedProps.room}
                        </Col>
                    </Row>
                )}
                <Row>
                    <Col sm={4}>
                        Straße
                    </Col>
                    <Col sm={8}>
                        {event.extendedProps.street} {event.extendedProps.houseNo}
                    </Col>
                </Row>
                {(event.extendedProps.additionToAddress != "" && event.extendedProps.additionToAddress != null)
                    ? <Row>
                        <Col sm={4}>
                            Adresszusatz
                        </Col>
                        <Col sm={8}>
                            {event.extendedProps.additionToAddress}
                        </Col>
                    </Row>
                    : ""}
                <Row>
                    <Col sm={4}>
                        Ort
                    </Col>
                    <Col sm={8}>
                        {event.extendedProps.postCode} {event.extendedProps.city}
                    </Col>
                </Row>
                <Row>
                    <Col sm={4}>
                        Datum
                    </Col>
                    <Col sm={8}>
                        {today}
                    </Col>
                </Row>
                <Row>
                    <Col sm={4}>
                        Zeitraum
                    </Col>
                    <Col sm={8}>
                        {String(new Date(event.start).getHours()).padStart(2, "0")}:{String(new Date(event.start).getMinutes()).padStart(2, "0")}
                        -
                        {String(new Date(event.end).getHours()).padStart(2, "0")}:{String(new Date(event.end).getMinutes()).padStart(2, "0")} Uhr
                    </Col>
                </Row>
                <Row>
                    <Col sm={4}>
                        Ablaufzeit
                    </Col>
                    <Col sm={8}>
                        {event.extendedProps.expiration} Stunden
                    </Col>
                </Row>
                <Row>
                    <Col sm={4}>
                        Ausstattung
                    </Col>
                    <Col sm={8}>
                        {event.extendedProps.equipment.join("; ")}
                    </Col>
                </Row>
                {/*<Row>*/}
                {/*    <Col sm={4}>*/}
                {/*        Führungszeugnis*/}
                {/*    </Col>*/}
                {/*    <Col sm={8}>*/}
                {/*        {event.extendedProps.criminalRecord ? "Notwendig" : "Nicht notwendig"}*/}
                {/*    </Col>*/}
                {/*</Row>*/}
                {business && (
                    <Row>
                        <Col sm={4}>
                            Unternehmen
                        </Col>
                        <Col sm={8}>
                            <a href={"/Operator/Business/" + business.OrganisationID}>{business.OrganisationName}</a>
                        </Col>
                    </Row>
                )}
                {business && (
                    <Row>
                        <Col sm={4}>
                            Straße
                        </Col>
                        <Col sm={8}>
                            {business.Street} {business.HouseNo}
                        </Col>
                    </Row>
                )}
                {business && (
                    <Row>
                        <Col sm={4}>
                            Ort
                        </Col>
                        <Col sm={8}>
                            {business.PostCode} {business.City}
                        </Col>
                    </Row>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={closeModal}>
                    Abbrechen
                </Button>
                {getButton(business, event)}
            </Modal.Footer>
        </Modal>
    )
};

const CalendarHeader = ({ calendarRef, filterTypeOfSchool, filterPostcode, filterPerimeter, setGradefilter, TypesOfSchool, setPostcodelistState, viewType, setState }) => {
    const { request } = useRequest();

    const [title, settitle] = useState(new Date().toLocaleString('de-DE', { month: 'short', year: 'numeric' }));
    const [types] = useState(TypesOfSchool.map((types) => { return { value: types.TypeOfSchoolID, label: types.Description }; }));
    const [disabled, setdisabled] = useState(true);

    const nextHandle = () => {
        calendarRef.current.getApi().next();
        settitle(calendarRef.current.getApi().currentDataManager.data.viewTitle);
    }
    const prevHandle = () => {
        calendarRef.current.getApi().prev();
        settitle(calendarRef.current.getApi().currentDataManager.data.viewTitle);
    }
    const todayHandle = () => {
        calendarRef.current.getApi().today();
        settitle(calendarRef.current.getApi().currentDataManager.data.viewTitle);
    }

    const monthViewHandle = () => {
        calendarRef.current.getApi().changeView('dayGridMonth')
    }

    useEffect(() => {
        settitle(calendarRef.current.getApi().currentDataManager.data.viewTitle);
    }, [viewType]);

    const marks = {
        0: '5',
        '12.5': '6',
        '25': '7',
        '37.5': '8',
        '50': '9',
        '62.5': '10',
        '75': '11',
        '87.5': '12',
        '100': '13'
    };

    const changeGrade = (value) => {
        setGradefilter({ min: marks[value[0]], max: marks[value[1]] });
    }

    const chosePostcodeFilter = (postCode) => {
        if (postCode.length == 5) {
            setdisabled(false);
        }
        else {
            setdisabled(true);
        }

        filterPostcode(postCode);
    }

    const chosePerimeterFilter = (perimeter) => {
        if (!perimeter) return;
        filterPerimeter(perimeter.value);
    }

    const changeState = async (e) => {
        if (e.target.value) {
            setState(e.target.value);
        } else {
            setState(false);
        }

        const result = await request("/Business/GetPostcodesInState", { state: e.target.value });
        const json = result.data;
        if (json.r == 1) {
            setPostcodelistState(json.postcodes);
        }
        else {
            toast.error(json.message);
        }
    };

    return (
        <Formik
            validationSchema={schema}
            validateOnChange={true}
            validateOnBlur={true}
            initialValues={{
                PostCode: '',
            }}
        >
            {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                touched,
                isValid,
                errors,
            }) => (
                <div className='mb-3' style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <div>
                        <ButtonGroup>
                            <button className="btn btn-primary" type="button" onClick={() => prevHandle()}><i className="fa fa-arrow-left"></i></button>
                            <span className="mx-2" style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "135px", fontWeight: "bold" }}>{title}</span>
                            <button className="btn btn-primary" type="button" onClick={() => nextHandle()}><i className="fa fa-arrow-right"></i></button>
                            <button className="btn btn-secondary ms-2" type="button" onClick={() => todayHandle()}>Heute</button>
                            {viewType != "dayGridMonth" && <button className="btn btn-secondary ms-2" type="button" onClick={() => monthViewHandle()}>Monatsansicht</button>}
                        </ButtonGroup>
                    </div>
                    <div className="d-flex justify-content-end align-items-start">
                        <div className="me-3" style={{ width: "236px" }}>
                            <Form.Label className="mb-0">Bundesland</Form.Label>
                            <Form.Select name="State" onChange={(e) => { handleChange(e); changeState(e) }}>
                                <option value="" key="">Kein Bundesland</option>
                                {states.map((item, index) => {
                                    return <option key={item.value} value={item.value}>{item.label}</option>
                                })}
                            </Form.Select>
                        </div>
                        <Form.Group controlId="PostCode" style={{ width: "85px" }} className="me-2">
                            <Form.Label className="mb-0">Postleitzahl</Form.Label>
                            <Form.Control isInvalid={errors.PostCode && touched.PostCode} type="text" name="PostCode" onChange={(e) => { handleChange(e); chosePostcodeFilter(e.currentTarget.value) }} onBlur={(e) => chosePostcodeFilter(e.currentTarget.value)} />
                            <Form.Control.Feedback type="invalid">{errors.PostCode}</Form.Control.Feedback>
                        </Form.Group>
                        <div className="me-3" style={{ width: "130px" }}>
                            <Form.Label className="mb-0">Umkreis</Form.Label>
                            <Select menuPortalTarget={document.body}
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                id="Perimeter" menuPosition={"fixed"} name="Perimeter" options={perimeters} className={"basic-multi-select" + disabled ? " select-disabled" : ""} onChange={(values) => { chosePerimeterFilter(values) }} placeholder="Keine" isDisabled={disabled} />

                        </div>
                        <div className="me-4" style={{ width: "225px" }}>
                            <Form.Label className="mb-0">Schulform</Form.Label>
                            <Select isMulti menuPortalTarget={document.body}
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                menuPosition={"fixed"} name="TypeOfSchool" options={types} className="basic-multi-select" onChange={(values) => { filterTypeOfSchool(values) }} placeholder="Alle" />
                        </div>
                        <div className="me-2" style={{ width: "220px" }}>
                            <Form.Label className="mb-1">Stufe</Form.Label>
                            <Slider
                                range
                                min={0}
                                marks={marks}
                                step={null}
                                onChange={changeGrade}
                                defaultValue={[0, 100]}
                                allowCross={false}
                                pushable
                            />
                        </div>
                    </div>
                </div>
            )}
        </Formik>
    );
}

function AllTimeslots() {
    const { request } = useRequest();
    const [timeslots, setTimeslots] = useState(false);
    const [modal, setModal] = useState(false);
    const [event, setEvent] = useState(false);
    const [postcodefilter, setPostcodefilter] = useState('');
    const [perimeterfilter, setPerimeterfilter] = useState(0);
    const [typeofschoolfilter, setTypeofschoolfilter] = useState([]);
    const [gradefilter, setGradefilter] = useState(false);
    const [view, setView] = useState("dayGridMonth");
    const [postcodelistPerimeter, setPostcodelistPerimeter] = useState([]);
    const [postcodelistState, setPostcodelistState] = useState([]);
    const [state, setState] = useState(false);
    const [year, setYear] = useState(new Date().getFullYear());
    const [month, setMonth] = useState(new Date().getMonth() + 1);
    const [loading, setLoading] = useState(false);
    const [timeslotCache, setTimeslotCache] = useState([]);

    const calendarRef = React.useRef()

    const { TypesOfSchool } = useContext(AppContext);

    const deleteTimeslots = (id) => {
        setTimeslots((items) => {
            var newItems = items.filter((timeslot) => {
                if (timeslot.TimeslotID == id) {
                    return false;
                }
                return true;
            });
            return newItems;
        });
    };

    const changeStatus = (id, status) => {
        setTimeslots((items) => {
            var newItems = items.map((timeslot) => {
                if (timeslot.TimeslotID == id) {
                    timeslot.Status = status;
                    timeslot.BookedBusiness = 0;
                }
                return timeslot;
            });
            return newItems;
        });
    };



    Date.prototype.addHours = function (h) {
        this.setTime(this.getTime() + (h * 60 * 60 * 1000));
        return this;
    }

    const getEndTime = (timeslot) => {
        let date = new Date(Date.parse(timeslot.Appointment + "T" + timeslot.TimeEnd));
        if (timeslot.TimeStart != timeslot.TimeEnd) {
            return timeslot.Appointment + "T" + timeslot.TimeEnd;
        } else {
            date.addHours(1);
            return date;
        }
    }

    const filterTypeOfSchool = (values) => {
        if (!values) return;
        setTypeofschoolfilter(values);
    }

    const filterPerimeter = async (values) => {
        if (!values) return;

        setPostcodelistPerimeter([]);
        if (values != null && postcodefilter != null) {
            if (values > 0 && postcodefilter.length == 5) {
                await getPostcodelist(values, postcodefilter);
            }
        }
        if (!(perimeterfilter == 0 && values == 0))
            setPerimeterfilter(values);
    }

    const setPostcode = async (postCode) => {
        setPostcodelistPerimeter([]);
        if (perimeterfilter != null && postCode != null) {
            if (perimeterfilter > 0 && postCode.length == 5) {
                await getPostcodelist(perimeterfilter, postCode);
            }
        }

        setPostcodefilter(postCode);
    }

    const getPostcodelist = async (perimeter, postcode) => {
        const result = await request("/Business/GetPostcodesInPerimeter", { perimeter, postcode });
        const json = result.data;
        if (json.r == 1) {
            setPostcodelistPerimeter(json.postcodes);
        }
        else {
            toast.error(json.message);
        }
    };

    const filterGrade = (grade) => {
        if (grade >= gradefilter.min && grade <= gradefilter.max) {
            return true;
        }

        return false;
    }

    const filterSchool = (school) => {
        for (let n = 0; n < typeofschoolfilter.length; n++) {
            if (school == typeofschoolfilter[n].label) {
                return true;
            }
        }

        return false;
    }

    useEffect(() => {
        filter();
    }, [postcodefilter, typeofschoolfilter, perimeterfilter, gradefilter, postcodelistPerimeter, postcodelistState, modal, timeslots]);

    const filter = () => {
        if (!calendarRef.current) return;

        let calendarApi =
            calendarRef.current.getApi().batchRendering(function () {
                let events = calendarRef.current.getApi().getEvents();
                for (let i = 0; i < events.length; i++) {
                    let event = events[i];
                    let display = true;

                    if (event.extendedProps.holiday) {
                        continue;
                    }

                    if (postcodelistState.length > 0) {
                        if (postcodelistState.indexOf(event.extendedProps.postCode) == -1) {
                            display = false;
                        }
                    }

                    // post code list
                    if (postcodelistPerimeter.length > 0) {
                        if (postcodelistPerimeter.indexOf(event.extendedProps.postCode) == -1) {
                            display = false;
                        }
                    }

                    // post code
                    if (postcodefilter.length > 0 && perimeterfilter == 0) {
                        if (!event.extendedProps.postCode.startsWith(postcodefilter)) {
                            display &&= false;
                        }
                    }

                    // type of school
                    if (typeofschoolfilter.length > 0) {
                        display &&= filterSchool(event.extendedProps.typeOfSchool);
                    }

                    // grade
                    if (gradefilter && gradefilter.min > 5 || gradefilter.max < 13) {
                        display &&= filterGrade(event.extendedProps.grade);
                    }

                    if (display) {
                        event.setProp('display', 'auto');
                    }
                    else {
                        event.setProp('display', 'none');
                    }
                }
            })
    }

    const loadTimeslots = async () => {
        try {
            const m = month;
            const y = year;
            let result = await request("/Operator/GetAllTimeslots", { month, year });
            let json = result.data;
            if (json.r != 1) {
                if (json.message) {
                    toast.error(json.message);
                }
                else {
                    toast.error("Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.");
                }

                setLoading(false);
                setTimeslots([]);
            }
            else {
                setLoading(false);
                setTimeslots(json.timeslots);

                setTimeslotCache(oldCache => {
                    let newCache = [...oldCache];
                    let fcache = oldCache.find(c => {
                        return c.month == m && c.year == y;
                    });

                    if (!fcache) {
                        newCache.push({
                            month: m,
                            year: y,
                            time: Date.now(),
                            data: json.timeslots
                        });
                    } else {
                        fcache.time = Date.now();
                        fcache.data = json.timeslots;
                    }

                    return newCache;
                });

                if (json.timeslots.length == 0) {
                    toast.info("Es wurden keine Termine gefunden.");
                }
            }
        }
        catch {
            setLoading(false);
            toast.error("Laden der Termine fehlgeschlagen.");
        }
    }

    useEffect(() => {
        //loadTimeslots();
        const interval = setInterval(() => {
            loadTimeslots();
        }, 900000);
        return () => clearInterval(interval);
    }, []);

    const events = useMemo(() => {
        let events = [];

        if (timeslots !== false) {
            events = timeslots.map((timeslot) => {
                return {
                    id: timeslot.TimeslotID,
                    title: "Klasse " + timeslot.Grade + " " + timeslot.Class,
                    start: timeslot.Appointment + "T" + timeslot.TimeStart,
                    end: getEndTime(timeslot),
                    display: "list-item",
                    extendedProps: {
                        organisationId: timeslot.OrganisationID,
                        organisationName: timeslot.OrganisationName,
                        street: timeslot.Street,
                        houseNo: timeslot.HouseNo,
                        additionToAddress: timeslot.AdditionToAddress,
                        city: timeslot.City,
                        postCode: timeslot.PostCode,
                        typeOfSchool: timeslot.TypeOfSchool,
                        class: timeslot.Class,
                        grade: timeslot.Grade,
                        room: timeslot.Room,
                        equipment: timeslot.Equipment.map((item) => { return item.Description; }),
                        expiration: timeslot.ExpireTime,
                        status: timeslot.Status,
                        bookedBusiness: timeslot.BookedBusiness,
                        criminalRecord: timeslot.CriminalRecord
                    },
                    allDay: false
                }
            });
        }

        let holidays = getHolidays(year, state);

        for (var i = 0; i < holidays.length; i++) {
            events.push({
                start: holidays[i].date,
                allDay: true,
                display: "background",
                color: "#f2f2f2",
                title: holidays[i].name,
                extendedProps: { holiday: true }
            });
        }

        return events;
    }, [timeslots, state, year]);

    useEffect(() => {
        let fcache = timeslotCache.find(m => {
            return m.month == month && m.year == year;
        });

        if (fcache && fcache.time + 1000 * 60 * 15 > Date.now()) {
            return setTimeslots(fcache.data);
        } else {
            //console.log("cache doesn't exist or to old");
        }

        setLoading(true);
        loadTimeslots();
    }, [month, year]);

    if (timeslots === false) return <Loader />

    return (
        <>
            <CalendarHeader
                calendarRef={calendarRef}
                filterTypeOfSchool={filterTypeOfSchool}
                filterPostcode={setPostcode}
                filterPerimeter={filterPerimeter}
                setGradefilter={setGradefilter}
                TypesOfSchool={TypesOfSchool}
                setPostcodelistState={setPostcodelistState}
                PostCode=''
                style={{ menu: provided => ({ ...provided, zIndex: 100 }) }}
                viewType={view}
                setState={setState}
            />

            <div style={{ menu: provided => ({ ...provided, zIndex: 200 }) }}>
                <FullCalendar ref={calendarRef}
                    selectable={true}
                    plugins={[dayGridPlugin, interactionPlugin]}
                    initialView={view}
                    //themeSystem='bootstrap'
                    weekNumbers={true}
                    weekends={true}
                    displayEventTime={true}
                    displayEventEnd={true}
                    firstDay='1'
                    locales={[deLocale]}
                    locale='de'
                    height='auto'
                    hiddenDays={[0]}
                    headerToolbar={false}
                    navLinks={true}
                    events={events}
                    eventTimeFormat={{
                        hour: '2-digit',
                        minute: '2-digit',
                        meridiem: false,
                        hour12: false
                    }}
                    eventClick={(info) => { setModal(true); setEvent(info.event); }}
                    views={{
                        dayGridMonth: {
                            dayMaxEvents: 6,
                        }
                    }}
                    datesSet={(info) => {
                        switch (info.view.type) {
                            case "dayGridMonth":
                                var date = new Date(info.startStr);
                                date.setDate(date.getDate() + 7);
                                var m = date.getMonth() + 1;
                                var y = date.getFullYear();
                                setMonth(m);
                                setYear(y);
                                break;
                            case "dayGridWeek":
                                var m = info.start.getMonth() + 1;
                                var y = info.start.getFullYear();
                                setMonth(m);
                                setYear(y);
                                break;
                            case "dayGridDay":
                                var m = info.start.getMonth() + 1;
                                var y = info.start.getFullYear();
                                setMonth(m);
                                setYear(y);
                                break;
                        }

                        setView(info.view.type);
                    }}
                />
            </div>

            {loading && (
                <div className="loading-wrapper-absolute">
                    <Loader />
                </div>
            )}

            <ModalForm modal={modal} setModal={setModal} event={event} deleteTimeslots={deleteTimeslots} changeStatus={changeStatus} />
        </>
    );
}

export default AllTimeslots;